export enum ProfileMetrics {
  'likes' = 'likes',
  'comments' = 'comments',
  'shares' = 'shares',
  'clicks' = 'clicks',
  'impressions' = 'impressions',
  'saves' = 'saves',
  'videoViews' = 'videosViews'
}
